/* =============================================================================
   Stambolian — collection filter drawer behaviour
   Adds price quick picks, a live results count in the drawer footer, an
   active-filter badge on the Filter button, Escape-to-close, and focus
   handling. Works on top of the theme's own CollectionFiltersForm.
   ============================================================================= */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function cff() {
    try { if (typeof CollectionFiltersForm !== 'undefined') return CollectionFiltersForm; } catch (e) {}
    return window.CollectionFiltersForm || null;
  }

  var TONES = {'Coral':'#e8836f','Labradorite':'#6f7f8a','Onyx':'#1d1d1f','Enamel':'linear-gradient(135deg,#2b4c9b,#c23a5e,#f0c35a)','Amethyst':'#8a63a8','Aquamarine':'#9fd0d6','Chrysoprase':'#7fbf9a','Diamond':'#e3e6e5','Emerald':'#2f7a4f','Garnet':'#7a1f2b','Gold':'linear-gradient(135deg,#d9b25a,#f3dc9a 55%,#c69a3e)','Kunzite':'#e5b7d1','Lapis Lazuli':'#274a8a','Moonstone':'#e9ecf2','Morganite':'#ddab91','Opal':'linear-gradient(135deg,#f4e9ee,#bfe1ee,#f9e6c8)','Pearl':'#f1ede4','Peridot':'#b5bd54','Peruvian Pink Opal':'#f0b9c0','Rose Gold':'linear-gradient(135deg,#d9a08c,#f1cbbd 55%,#c98d78)','Rubellite':'#9e4265','Ruby':'#a3182f','Sapphire':'#3d5a99','Tanzanite':'#5a4da3','Topaz':'#6fb7e3','Tourmaline':'#927153','Tsavorite':'#4d7961','Turquoise':'#4fb3b1','White Gold':'linear-gradient(135deg,#d7d9dc,#f4f5f6 55%,#c2c5c9)','Zircon':'#5fa9d6','Yellow Gold':'linear-gradient(135deg,#d9b25a,#f3dc9a 55%,#c69a3e)','Silver':'linear-gradient(135deg,#cfd2d6,#f2f3f4 55%,#b9bcc1)','Citrine':'#e6b84a','Jade':'#5f9c6f','Malachite':'#2e8b57','Mother Of Pearl':'#f3efe6','Quartz':'#e9dfe0'};

  /* Display-only text polish: the theme's data labels are stored in capitals; the approved design shows title case. */
  function titleCase(s) {
    var t = s.replace(/^\s*-\s*/, '').trim();
    if (!t) return s;
    var hasLower = /[a-z]/.test(t);
    var words = t.split(/\s+/).map(function (w) {
      if (/\d/.test(w)) return w;                      // keep 18K, etc.
      if (hasLower && w !== w.toUpperCase()) return w;  // already mixed case, leave it
      var lw = w.toLowerCase();
      if (['of','and','the','&','/'].indexOf(lw) >= 0 && w !== t.split(/\s+/)[0]) return lw === '&' || lw === '/' ? w : lw;
      return lw.charAt(0).toUpperCase() + lw.slice(1);
    });
    return words.join(' ');
  }
  function polishText(el) {
    if (!el || el.getAttribute('data-stbl-polished') === '1') return;
    Array.prototype.forEach.call(el.childNodes, function (n) {
      if (n.nodeType === 3 && n.textContent.trim()) n.textContent = ' ' + titleCase(n.textContent) + ' ';
    });
    el.setAttribute('data-stbl-polished', '1');
  }
  function labelKey(el) {
    var t = '';
    Array.prototype.forEach.call(el.childNodes, function (n) { if (n.nodeType === 3) t += n.textContent; });
    return t.trim();
  }
  function polishOptions(root) {
    root.querySelectorAll('.facets__list .list-menu__item .facet-checkbox').forEach(function (label) {
      polishText(label);
      if (label.querySelector('.stbl-stone-dot')) return;
      var key = labelKey(label);
      var tone = TONES[key] || TONES[key.replace(/\bgold\b/i, 'Gold')] || null;
      if (tone) {
        var dot = document.createElement('span');
        dot.className = 'stbl-stone-dot';
        dot.setAttribute('aria-hidden', 'true');
        dot.style.setProperty('--stone-tone', tone);
        label.insertBefore(dot, label.firstChild);
      }
    });
    root.querySelectorAll('.sidebarBlock-heading .facets__text, .facets__list--refined .active-facets__button .text').forEach(polishText);
    // Approved design shows every option; expand the theme's "Show all" once per block, then the button is hidden by CSS.
    root.querySelectorAll('.show-more--list_tags').forEach(function (btn) {
      var block = btn.closest('.js-filter');
      if (block && !block.classList.contains('show-more')) btn.click();
    });
  }

  function money(n) {
    return '$' + Number(n).toLocaleString('en-US');
  }

  ready(function () {
    var section = document.querySelector('.collection-default');
    var sidebar = document.getElementById('halo-sidebar');
    if (!section || !sidebar) return;

    var toggle = section.querySelector('[data-sidebar]');
    var closeBtn = sidebar.querySelector('.halo-sidebar-close');
    var threshold = parseInt(sidebar.getAttribute('data-stbl-quick-threshold'), 10);
    if (!threshold || threshold < 1) threshold = 10000;
    var labelAll = sidebar.getAttribute('data-stbl-label-all') || 'All pieces';
    var labelUnder = sidebar.getAttribute('data-stbl-label-under') || ('Under ' + money(threshold));
    var labelAbove = sidebar.getAttribute('data-stbl-label-above') || (money(threshold) + ' and above');
    var pieceOne = sidebar.getAttribute('data-stbl-piece-one') || 'piece';
    var pieceMany = sidebar.getAttribute('data-stbl-piece-many') || 'pieces';

    /* ---------- Price quick picks ---------- */
    function priceBlock() {
      return sidebar.querySelector('.js-filter[data-type-price]');
    }

    function priceInputs() {
      var block = priceBlock();
      if (!block) return null;
      return {
        block: block,
        min: block.querySelector('.filter__price--min'),
        max: block.querySelector('.filter__price--max'),
        rMin: block.querySelector('.filter__price_min'),
        rMax: block.querySelector('.filter__price_max'),
        apply: block.querySelector('#filter__price--apply')
      };
    }

    function currentPick() {
      var p = priceInputs();
      if (!p || !p.min || !p.max) return 'all';
      var min = p.min.value === '' ? 0 : Number(p.min.value);
      var rangeMax = Number(p.max.getAttribute('max')) || Infinity;
      var max = p.max.value === '' ? rangeMax : Number(p.max.value);
      if (min === 0 && max >= threshold - 1 && max < threshold) return 'under';
      if (min === threshold && max >= rangeMax) return 'above';
      if (min === 0 && max >= rangeMax) return 'all';
      return 'custom';
    }

    function ensureQuickPicks() {
      var block = priceBlock();
      if (!block) return;
      var existing = sidebar.querySelector('.stbl-price-quick');
      // Keep the quick picks directly above the price controls inside the block's content.
      var content = block.querySelector('.facets__price');
      if (!content) return;
      if (existing && existing.parentNode === content.parentNode && existing.nextElementSibling === content) {
        syncQuickPicks();
        return;
      }
      if (existing) existing.remove();
      var wrap = document.createElement('div');
      wrap.className = 'stbl-price-quick';
      wrap.setAttribute('role', 'group');
      wrap.setAttribute('aria-label', 'Quick price ranges');
      [['all', labelAll], ['under', labelUnder], ['above', labelAbove]].forEach(function (def) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = def[1];
        b.setAttribute('data-stbl-pick', def[0]);
        b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () { applyPick(def[0]); });
        wrap.appendChild(b);
      });
      content.parentNode.insertBefore(wrap, content);
      syncQuickPicks();
    }

    function syncQuickPicks() {
      var pick = currentPick();
      sidebar.querySelectorAll('.stbl-price-quick button').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-stbl-pick') === pick));
      });
    }

    function applyPick(pick) {
      var p = priceInputs();
      if (!p || !p.min || !p.max) return;
      var rangeMax = Number(p.max.getAttribute('max')) || 0;
      if (pick === 'all') {
        p.min.value = '';
        p.max.value = '';
        if (p.rMin) p.rMin.value = 0;
        if (p.rMax) p.rMax.value = rangeMax;
        var form = p.block.closest('form');
        var C = cff();
        if (form && C) {
          var data = new FormData(form);
          data.delete(p.min.name);
          data.delete(p.max.name);
          C.renderPage(new URLSearchParams(data).toString(), null);
        }
      } else if (pick === 'under') {
        p.min.value = '';
        p.max.value = String(threshold - 1);
        if (p.rMin) p.rMin.value = 0;
        if (p.rMax) p.rMax.value = threshold - 1;
        if (p.apply) p.apply.click();
      } else if (pick === 'above') {
        p.min.value = String(threshold);
        p.max.value = '';
        if (p.rMin) p.rMin.value = threshold;
        if (p.rMax) p.rMax.value = rangeMax;
        if (p.apply) p.apply.click();
      }
      syncQuickPicks();
    }

    /* ---------- Footer: results count + clear all ---------- */
    function resultsCount() {
      var el = section.querySelector('.toolbar .results-count .count') || sidebar.querySelector('.results-count .count');
      var n = el ? parseInt(el.textContent.replace(/[^0-9]/g, ''), 10) : NaN;
      if (isNaN(n)) n = parseInt(sidebar.getAttribute('data-stbl-count'), 10) || 0;
      return n;
    }

    function syncFooter() {
      var target = sidebar.querySelector('[data-stbl-count-target]');
      var word = sidebar.querySelector('[data-stbl-count-word]');
      var n = resultsCount();
      if (target) target.textContent = n.toLocaleString('en-US');
      if (word) word.textContent = n === 1 ? pieceOne : pieceMany;
    }

    function activeCount() {
      return sidebar.querySelectorAll('.facets__list--refined li').length;
    }

    function syncBadge() {
      if (!toggle) return;
      var badge = toggle.querySelector('.stbl-filter-badge');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'stbl-filter-badge';
        toggle.querySelector('.toolbar-icon').appendChild(badge);
      }
      var n = activeCount();
      badge.textContent = n;
      badge.classList.toggle('is-visible', n > 0);
      var clear = sidebar.querySelector('[data-stbl-clear]');
      if (clear) clear.style.visibility = n > 0 ? 'visible' : 'hidden';
    }

    var clearBtn = sidebar.querySelector('[data-stbl-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var link = sidebar.querySelector('.refined-widgets .facets__clear-all');
        if (link) { link.click(); return; }
        var C = cff();
        if (C) C.renderPage('', null);
      });
    }

    /* ---------- Open / close niceties ---------- */
    var lastFocus = null;
    if (toggle) {
      toggle.setAttribute('role', 'button');
      toggle.setAttribute('tabindex', '0');
      toggle.setAttribute('aria-haspopup', 'dialog');
      toggle.setAttribute('aria-controls', 'halo-sidebar');
      toggle.addEventListener('click', function () {
        lastFocus = toggle;
        setTimeout(function () { if (closeBtn) closeBtn.focus(); }, 60);
      });
      toggle.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle.click(); }
      });
    }
    sidebar.setAttribute('role', 'dialog');
    sidebar.setAttribute('aria-modal', 'true');
    sidebar.setAttribute('aria-label', 'Filter and refine');

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('open-mobile-sidebar')) {
        document.body.classList.remove('open-mobile-sidebar');
        if (lastFocus) lastFocus.focus();
      }
    });

    var bodyObserver = new MutationObserver(function () {
      var open = document.body.classList.contains('open-mobile-sidebar');
      if (toggle) toggle.setAttribute('aria-expanded', String(open));
      if (!open && lastFocus && document.activeElement && sidebar.contains(document.activeElement)) lastFocus.focus();
    });
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    /* ---------- Keep everything in sync as the theme re-renders filters ---------- */
    var pending = null;
    function syncAll() {
      polishOptions(sidebar);
      ensureQuickPicks();
      syncFooter();
      syncBadge();
    }
    function scheduleSync() {
      if (pending) return;
      pending = setTimeout(function () { pending = null; syncAll(); }, 80);
    }
    var form = sidebar.querySelector('#CollectionFiltersForm');
    if (form) new MutationObserver(scheduleSync).observe(form, { childList: true, subtree: true });
    var count = section.querySelector('.toolbar .results-count');
    if (count) new MutationObserver(scheduleSync).observe(count, { childList: true, subtree: true, characterData: true });
    if (form) form.addEventListener('input', function () { setTimeout(syncQuickPicks, 0); });

    syncAll();
  });
})();
